const EM_DASH = '—';

function pad2(n: number): string {
  return String(n).padStart(2, '0');
}

/**
 * Full datetime with local clock time and GMT offset, matching:
 * `YYYY-MM-DD HH:mm:ss GMT±HH:mm` (e.g. `2018-09-02 12:29:58 GMT-04:00`).
 */
export function formatDateTimeGmt(iso: string | null | undefined): string {
  if (iso == null || String(iso).trim() === '') return EM_DASH;
  const d = new Date(String(iso).trim());
  if (Number.isNaN(d.getTime())) return EM_DASH;
  const y = d.getFullYear();
  const mo = pad2(d.getMonth() + 1);
  const day = pad2(d.getDate());
  const h = pad2(d.getHours());
  const mi = pad2(d.getMinutes());
  const s = pad2(d.getSeconds());
  const offMin = -d.getTimezoneOffset();
  const sign = offMin >= 0 ? '+' : '-';
  const abs = Math.abs(offMin);
  const oh = pad2(Math.floor(abs / 60));
  const omi = pad2(abs % 60);
  return `${y}-${mo}-${day} ${h}:${mi}:${s} GMT${sign}${oh}:${omi}`;
}

/**
 * Calendar date only (`YYYY-MM-DD`) → same pattern at UTC midnight.
 * ISO timestamps fall through to {@link formatDateTimeGmt}.
 */
export function formatDateOrDateTimeGmt(value: string | null | undefined): string {
  if (value == null || String(value).trim() === '') return EM_DASH;
  const s = String(value).trim();
  if (/^\d{4}-\d{2}-\d{2}$/.test(s)) {
    return `${s} 00:00:00 GMT+00:00`;
  }
  return formatDateTimeGmt(s);
}
